export * from "./userActions";

export const showLoader = () => {
	return { type: "SHOW_BTN_LOADING" };
};

export const hideLoader = () => {
	return { type: "HIDE_BTN_LOADING" };
};

export const SET_MENU_ACTIVATED = "SET_MENU_ACTIVATED";

export const setMenuActivated = (menus) => (dispatch) => {
	dispatch({ type: SET_MENU_ACTIVATED, payload: menus });
};

// export default {};
